import EcalBackground from '../../../../commons/images/brandImage/ECALWhiteLabel2.jpg';

export default {
    labelName: 'ecal',
    favicon: '/favicon.ico?v=3',
    title: 'Admin ECAL',
    background: EcalBackground,
    footerColor: '#010134',
    headerColor: '#010134',
    logo: '/assets/ECAL_Logo.svg?v=2',
    copyrightText: `© 2010-${new Date().getFullYear()} | ECAL | HyperKu Pte Ltd | All rights reserved.`,
    supportContact: 'support@ecal.com',
    hideIntercomChat: false, /* hide_default_launcher */
    supportLabel: 'ECAL Support',
    sidebar: 'ecal',
    autoLoginValue: 'ecal',
};
